export { default as NAlert, alertProps } from './src/Alert';
